import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
 
import Wrapper from "../../components/Wrapper";
import { FcPaid } from "react-icons/fc";
import { LuMerge } from "react-icons/lu";
const Dailytaxobligation = ()=>{
    const [dailytaxobligation, setDailytaxobligation] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [selectedTax, setSelectedTax] = useState(null);
    const [taxDate, setTaxDate] = useState("");
    const [taxType, setTaxType] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [hasError, setHasError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [taxArray, setTaxArray] = useState([]);
    const [showModalMerged, setShowModalMerged] = useState(false);
    const [mergedTaxOnDeposit, setMergedTaxOnDeposit] = useState(0);
    const [mergedTaxOnWithdrawal, setMergedTaxOnWithdrawal] = useState(0);
    const [mergedTaxDate, setMergedTaxDate] = useState("");
    const[mergedDepositArray,setMergedDepositArray] = useState([]);
    const[mergedWithdrawalArray,setMergedWithdrawalArray] = useState([]);
    
    const handleTaxClick = (amount, date, type) => {
      setSelectedTax(amount);
      setTaxDate(date);
      setTaxType(type);
      setShowModal(true);
    };
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`dailyTaxObligation?page=${page}`);
            setDailytaxobligation(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`dailytaxobligation/${id}`);
            setDailytaxobligation(dailytaxobligation.filter((dailytaxobligation) => dailytaxobligation.id !== id));
        }
    }

    const addToTaxArray = (id,depositAmount,withdrawalAmount) => {
        setTaxArray((prevArray) => [...prevArray, id]);
        setMergedTaxOnDeposit((prev) => prev + depositAmount);
        setMergedTaxOnWithdrawal((prev) => prev + withdrawalAmount);

    }
    const removeFromTaxArray = (id,depositAmount,withdrawalAmount) => {
        setTaxArray((prevArray) => prevArray.filter((item) => item !== id));
        setMergedTaxOnDeposit((prev) => prev - depositAmount);
        setMergedTaxOnWithdrawal((prev) => prev - withdrawalAmount);
    }

    const mergeAndPay =   () => {
      if (taxArray.length === 0) {
        alert("Please select at least one tax obligation to merge and pay.");
        return;
      }
      setShowModalMerged(true);
    }
 
    return (
        <Wrapper pageTitle={'Daily Tax Obligation'}>
            <div className="px-4 py-5">
              <button className="px-4 " onClick={()=>mergeAndPay()}> <LuMerge/> Merge & Pay</button> <button  className="px-4 "> <FcPaid />Mark as Paid</button> 
            </div>
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-white uppercase border-b dark:border-gray-700 bg-[#319DE5] dark:text-gray-400 dark:bg-gray-800" >
                                  <th className="px-4 py-3"><input type="checkbox"/></th>
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Tax Date </th>
                                    <th className="px-4 py-3">Deposit Total </th>
                                    <th className="px-4 py-3">Withdrawal Total </th>
                                    <th className="px-4 py-3">Tax On Deposit </th>
                                    <th className="px-4 py-3">Tax On Withdrawal </th>
                                    <th className="px-4 py-3">Total Tax Amount </th>
                                    <th className="px-4 py-3">Trx Code </th>
                                    <th className="px-4 py-3">Prn Code </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 border-r-[1px] border-[#319DE5] border-l-[1px] border-[#319DE5] border-b-[1px] border-[#319DE5]" >
                                    {dailytaxobligation && dailytaxobligation.length > 0 ? (
                                         dailytaxobligation.map((dailytaxobligation)=>(
                                             <tr key={dailytaxobligation.id} className="text-gray-700 dark:text-gray-400">
                                              <td className="px-4 py-5"><input type="checkbox"  onChange={(e) => {
                                                if (e.target.checked) {
                                                  addToTaxArray(dailytaxobligation.id,dailytaxobligation.tax_on_deposit,dailytaxobligation.tax_on_withdrawal);
                                                } else {
                                                  removeFromTaxArray(dailytaxobligation.id,dailytaxobligation.tax_on_deposit,dailytaxobligation.tax_on_withdrawal);
                                                }
                                              }}/> 
                                              </td>
                                                 <td className="px-4 py-5">{dailytaxobligation.id}</td>
                                                 <td className="px-4 py-3 text-sm">{dailytaxobligation.tax_date}</td>
                                                 <td className="px-4 py-3 text-sm">{dailytaxobligation.deposit_total}</td>
                                                 <td className="px-4 py-3 text-sm">{dailytaxobligation.withdrawal_total}</td>
                                                 <td className="px-4 py-3 text-sm"  onClick={() => handleTaxClick(dailytaxobligation.tax_on_deposit, dailytaxobligation.tax_date, "deposit")}>{dailytaxobligation.tax_on_deposit}</td>
                                                 <td className="px-4 py-3 text-sm" onClick={() => handleTaxClick(dailytaxobligation.tax_on_withdrawal, dailytaxobligation.tax_date, "withdrawal")}>{dailytaxobligation.tax_on_withdrawal}</td>
                                                 <td className="px-4 py-3 text-sm">{dailytaxobligation.total_tax_amount}</td>
                                                 <td className="px-4 py-3 text-sm">{dailytaxobligation.trx_code}</td>
                                                 <td className="px-4 py-3 text-sm">{dailytaxobligation.prn_code}</td>
                                                 <td className="flex px-4 py-3 text-sm">  </td>
                                             </tr>
                                         ))
                                ) : (
                                            <tr>
                                                <td colSpan="10" className="text-center py-5 text-gray-500">No data to display </td>
                                            </tr>
                                         )}
                            </tbody>
                        </table>
                        {showModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded shadow-md w-96">
      <h2 className="text-lg font-bold mb-4">Submit Tax Info</h2>

      <form
        onSubmit={async (e) => {
          e.preventDefault();
          setLoading(true);
          try {
            const { data } = await axios.post("prnRequest", {
              transDate: taxDate,
              amount: Math.ceil(Number(selectedTax)), // ceil as int,
              taxType,
              salt: "8a00ba4511j3jpcc32dq6dbf6bef9bd2b",
            });

            setHasError(false);
            setRedirect(true);
            setShowModal(false);
          } catch (error) {
            if (error.message === "Network Error") {
              setErrorMessage("Failed to connect to the server. Please try again later.");
            } else if (error.code === "ERR_BAD_REQUEST") {
              setErrorMessage("Wrong Email or password. Try again");
            } else {
              setErrorMessage("An error occurred. Please try again later.");
            }
            setHasError(true);
          } finally {
            setLoading(false);
          }
        }}
      >
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Amount</label>
          <input
            type="text"
            value={Math.ceil(Number(selectedTax)) ?? ""}
            disabled
            className="mt-1 block w-full px-3 py-2 border rounded-md bg-gray-100"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Tax Date</label>
          <input
            type="text"
            value={taxDate}
            disabled
            className="mt-1 block w-full px-3 py-2 border rounded-md bg-gray-100"
          />
        </div>

        <input type="hidden" value={taxType} name="taxType" />

        {hasError && <p className="text-red-500 text-sm mb-2">{errorMessage}</p>}

        <div className="flex justify-between mt-6">
          <button
            type="button"
            onClick={() => setShowModal(false)}
            className="px-4 py-2 bg-gray-500 text-white rounded"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

{/* show merged totals for both tax_on_deposit and tax_on_withdrawal */}
{showModalMerged && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded shadow-md w-96">
      <h2 className="text-lg font-bold mb-4">Pay Merged Taxes</h2>

      <form
        onSubmit={async (e) => {
          e.preventDefault();
          setLoading(true);
          try {
            const { data } = await axios.post("mergeAndPay", {
              taxIds: taxArray,
              taxOnDeposit: Math.ceil(Number(mergedTaxOnDeposit)),
              taxOnWithdrawal: Math.ceil(Number(mergedTaxOnWithdrawal)),
              taxDate: mergedTaxDate, // Assuming you want to use the same date for both
              salt: "8a00ba4511j3jpcc32dq6dbf6bef9bd2b",
            });

            setHasError(false);
            setRedirect(true);
            setShowModalMerged(false);
            alert("Merge and Pay successful!");
          } catch (error) {
            if (error.message === "Network Error") {
              setErrorMessage("Failed to connect to the server. Please try again later.");
            } else if (error.code === "ERR_BAD_REQUEST") {
              setErrorMessage("Wrong Email or password. Try again");
            } else {
              setErrorMessage("An error occurred. Please try again later.");
            }
            setHasError(true);
          } finally {
            setLoading(false);
          }
        }}
      >
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Excise Amount (Deposit  Totals)</label>
          <input
            type="text"
            value={Math.ceil(Number(mergedTaxOnDeposit)) ?? ""}
            disabled
            className="mt-1 block w-full px-3 py-2 border rounded-md bg-gray-100"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">WHT Amount (Withdrawal Totals)</label>
          <input
            type="text"
            value={Math.ceil(Number(mergedTaxOnWithdrawal)) ?? ""}
            disabled
            className="mt-1 block w-full px-3 py-2 border rounded-md bg-gray-100"
          />
        </div>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">Tax Date</label>
          <input type="date"
            value={mergedTaxDate}
            onChange={(e) => setMergedTaxDate(e.target.value)}
            required
            className="mt-1 block w-full px-3 py-2 border rounded-md bg-gray-100"
          />
        </div>

  

        {hasError && <p className="text-red-500 text-sm mb-2">{errorMessage}</p>}

        <div className="flex justify-between mt-6">
          <button
            type="button"
            onClick={() => setShowModalMerged(false)}
            className="px-4 py-2 bg-gray-500 text-white rounded"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Dailytaxobligation;